
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agb-b2c",
      function () {
        return require("private-next-pages/agb-b2c.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agb-b2c"])
      });
    }
  